// @flow
import React, { Component } from 'react';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import DrugTable from './DrugTable.jsx';

class StockReportPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Stock Report" />
        <ContentBox id="outOfStock" title="Out of Stock">
          <DrugTable category='outOfStock' />
        </ContentBox>
        <ContentBox id="lowStock" title="Low Stock (<10 Units)">
          <DrugTable category='lowStock' />
        </ContentBox>
      </div>
    );
  }
}

export default StockReportPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/StockReportPage.jsx